import React, { useEffect, useRef, useState } from "react";
import { MdArrowDropDown, MdMenu } from "react-icons/md";
import "../Header/Header.css";
import { FaRegUserCircle } from "react-icons/fa";
import websitelogo from "../../Assets/projectlogo.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  APIUrl,
  APIUrlToken,
  getIsUser,
  SetlocalStorage,
} from "../../Utils/Utils";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import axios from "axios";
import {
  Button,
  Menu,
  MenuItem,
  Popover,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import SiteSearch from "../SiteSearch/SiteSearch";

const Header = () => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAdminDropdown, setIsAdminDropdown] = useState(false);
  const [userLoginDetails, setUserLoginDetails] = useState(getIsUser());
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFallback(true);
    }, 2000); // 2 seconds

    return () => clearTimeout(timer);
  }, []);
  const dropdownRef = useRef(null);
  const adminDropdownRef = useRef(null);
  const { loginWithRedirect, logout, user, isAuthenticated, getIdTokenClaims } =
    useAuth0();

  const [activeLink, setActiveLink] = useState("home");
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  // NEW: modal state for Add Details form
  const [isAddDetailsOpen, setIsAddDetailsOpen] = useState(false);
  const openAddDetails = () => setIsAddDetailsOpen(true);
  const closeAddDetails = () => setIsAddDetailsOpen(false);

  const handleLoginIn = async () => {
    // Come back to whatever page the user was on when they logged in.
    await loginWithRedirect({
      appState: { returnTo: location.pathname + location.search },
    });
  };

  const syncUserWithBackend = async (auth0User) => {
    const url = `${APIUrl()}/v1/local/auth/sync`;

    try {
      const response = await axios.post(url, auth0User, {
        headers: { "X-API-Key": APIUrlToken() },
      });

      const { user_id, user_email, user_role, given_name, player_id } =
        response.data;

      const userData = {
        user_id,
        user_email,
        given_name,
        player_id,
      };

      SetlocalStorage("nilUser", userData);
      localStorage.setItem("user_role", user_role);

      // Update React state too, so the header re-renders as signed in.
      setUserLoginDetails(userData);
    } catch (error) {
      toast.error("User not Found. Please contact us");
      localStorage.clear();
      logout({ logoutParams: { returnTo: window.location.origin } });
    }
  };
  useEffect(() => {
    setUserLoginDetails(getIsUser());
  }, []);

  const handleCreateAthleteProfile = (e) => {
    e.preventDefault();
    setActiveLink("createAthleteProfile");
    navigate("/CreateAthleteProfile");
  };

  const handleLogout = () => {
    localStorage.clear();
    setUserLoginDetails(null);
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const handleHomePageLogo = () => {
    setActiveLink("home");
    navigate("/");
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setIsAdminDropdown(false);
  };

  const toggleAdminDropdown = () => {
    setIsAdminDropdown(!isAdminDropdown);
    setIsDropdownOpen(false);
  };

  const handleHomePage = (e) => {
    e.preventDefault();
    setActiveLink("home");
    navigate("/");
  };

  const handleAboutUs = (e) => {
    e?.preventDefault();
    setActiveLink("about");
    navigate("/AboutUs");
  };

  const handleFavoriteAthletes = (e) => {
    e.preventDefault();
    setActiveLink("favorites");
    navigate("/favorites");
  };

  const handleImpactAthleteJourney = (e) => {
    e.preventDefault();
    setActiveLink("ImpactAthleteJourney");
    navigate("/ImpactAthleteJourney");
  };
  const handleAboutMission = (e) => {
    e.preventDefault();
    setActiveLink("BuildingTrustInNIL");
    navigate("/BuildingTrustInNIL");
  };
  const handleNILComplianceAndProcedures = (e) => {
    e.preventDefault();
    setActiveLink("NILComplianceAndProcedures");
    navigate("/NILComplianceAndProcedures");
  };

  const handleAddressingNilInequalityClick = (e) => {
    e.preventDefault();
    setActiveLink("AddressingNILInequality");
    navigate("/AddressingNILInequality");
  };

  const handleNILSupportServicesAndFeesClick = (e) => {
    e.preventDefault();
    setActiveLink("NILSupportServices");
    navigate("/NILSupportServices");
  };

  const handleProfile = (e) => {
    e.preventDefault();
    setActiveLink("AccountInformation");
    navigate("/AccountInformation");
  };

  const handleDeleteAccount = (e) => {
    e.preventDefault();
    setActiveLink("DeleteScreen");
    navigate("/DeleteScreen");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        adminDropdownRef.current &&
        !adminDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
        setIsAdminDropdown(false);
      }
    };

    if (isDropdownOpen || isAdminDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen, isAdminDropdown]);

  useEffect(() => {
    let timeoutId;

    const checkToken = async () => {
      if (!isAuthenticated) {
        localStorage.clear();
        return;
      }

      try {
        const claims = await getIdTokenClaims();
        const exp = claims?.exp * 1000;
        const now = Date.now();
        const timeout = exp - now;

        if (timeout <= 0) {
          localStorage.clear();
          logout({ logoutParams: { returnTo: window.location.origin } });
        } else {
          timeoutId = setTimeout(() => {
            logout({ logoutParams: { returnTo: window.location.origin } });
          }, timeout);
        }
      } catch (err) {
        console.error("Token error:", err);
      }
    };

    checkToken();

    return () => clearTimeout(timeoutId);
  }, [isAuthenticated, getIdTokenClaims, logout]);

  useEffect(() => {
    if (isAuthenticated && user) {
      syncUserWithBackend(user);
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveLink("home");
    else if (path.startsWith("/browse")) setActiveLink("browse");
    else if (path.startsWith("/sports")) setActiveLink("sports");
    else if (path === "/AboutUs") setActiveLink("about");
    else if (path === "/favorites") setActiveLink("favorites");
    else if (path === "/ImpactAthleteJourney")
      setActiveLink("ImpactAthleteJourney");
    else if (path === "/BuildingTrustInNIL")
      setActiveLink("BuildingTrustInNIL");
    else if (path === "/NILComplianceAndProcedures")
      setActiveLink("NILComplianceAndProcedures");
    else if (path === "/NILSupportServices")
      setActiveLink("NILSupportServices");
    else if (path === "/AddressingNILInequality")
      setActiveLink("AddressingNILInequality");
    else if (path === "/AccountInformation")
      setActiveLink("AccountInformation");
    else if (path === "/DeleteScreen") setActiveLink("DeleteScreen");
  }, [location.pathname]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const open = Boolean(anchorEl);
  const [whyDonateAnchorEl, setWhyDonateAnchorEl] = useState(null);
  const [accountAnchorEl, setAccountAnchorEl] = useState(null);

  const isWhyDonateOpen = Boolean(whyDonateAnchorEl);
  const isAccountOpen = Boolean(accountAnchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleWhyDonateOpen = (event) => {
    setWhyDonateAnchorEl(event.currentTarget);
    setAccountAnchorEl(null);
  };

  const handleAccountOpen = (event) => {
    setAccountAnchorEl(event.currentTarget);
    setWhyDonateAnchorEl(null);
  };

  const handleWhyDonateClose = () => {
    setWhyDonateAnchorEl(null);
  };

  const handleAccountClose = () => {
    setAccountAnchorEl(null);
  };
  const [profileInfo, setProfileInfo] = useState(
    localStorage.getItem("first_name") || ""
  );
  const getProfileInfoEdit = () => {
    const url = `${APIUrl()}/v1/user-profiles/${userLoginDetails?.user_id}`;

    axios
      .get(url, { headers: { "X-API-Key": APIUrlToken() } })
      .then((response) => {
        const firstName = response?.data?.first_name;

        // Only update if valid
        if (firstName) {
          setProfileInfo(firstName);
          localStorage.setItem("first_name", firstName);
        }
      })
      .catch((error) => {
        console.error("Error fetching profile data:", error);
      });
  };

  useEffect(() => {
    if (userLoginDetails?.user_id) {
      getProfileInfoEdit();
    }
  }, [userLoginDetails]);

  return (
    <div className="header-nil-d">
      {isMobile ? (
        <>
          <header className="navbar-container d-flex navbar-flex">
            <div className="navbar-logo d-none d-lg-block">
              <div onClick={handleHomePageLogo} className="nil-head-2">
                <img src={websitelogo} alt="Logo" className="websitelogo" />{" "}
                NIL-Collab
              </div>
            </div>

            <Button style={{ color: "#ffffff" }} onClick={handleClick}>
              {userLoginDetails?.user_id ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "7px" }}
                >
                  <p className="user-entry-hdr">
                    {userLoginDetails?.given_name
                      ? userLoginDetails.given_name.charAt(0)
                      : userLoginDetails?.user_email?.charAt(0)}
                  </p>
                  <IoIosArrowDown />
                </div>
              ) : (
                <div>
                  <span className="navbar-btn navbar-login-res">
                    <FaRegUserCircle /> Login
                    <IoIosArrowDown />
                  </span>
                </div>
              )}
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              {/* NEW: Add Details first item in mobile menu */}
              <MenuItem
                onClick={() => {
                  handleClose();
                  openAddDetails();
                }}
              >
                {/* <span className="navbar-link">
                  Get Recognized Today <br /> Create your Athlete NIL Profile
                </span> */}
              </MenuItem>

              <MenuItem onClick={handleHomePage}>
                <span
                  className={`navbar-link ${
                    activeLink === "home" ? "active" : ""
                  }`}
                >
                  Home
                </span>
              </MenuItem>

              {userLoginDetails?.user_id && (
                <MenuItem onClick={handleFavoriteAthletes}>
                  <span
                    className={`navbar-link ${
                      activeLink === "favorites" ? "active" : ""
                    }`}
                  >
                    Favorite Athletes
                  </span>
                </MenuItem>
              )}

              <MenuItem onClick={handleAboutUs}>
                <span
                  className={`navbar-link-dropdown ${
                    activeLink === "about" ? "active" : ""
                  }`}
                >
                  About Us
                </span>
              </MenuItem>

              <MenuItem
                onMouseEnter={handleWhyDonateOpen}
                onMouseLeave={handleWhyDonateClose}
              >
                <button
                  onClick={toggleDropdown}
                  aria-label="Why Contribute menu"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "none",
                    border: "none",
                    padding: "0.5rem",
                    cursor: "pointer",
                  }}
                >
                  <MdMenu size={24} />
                  <span style={{ marginLeft: "0.5rem" }}>Why Contribute</span>
                </button>
                <Popover
                  open={isWhyDonateOpen}
                  anchorEl={whyDonateAnchorEl}
                  onClose={handleWhyDonateClose}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                  PaperProps={{
                    sx: {
                      maxWidth: "80vw",
                      maxHeight: "60vh",
                      overflow: "auto",
                    },
                  }}
                >
                  <MenuItem onClick={handleAboutMission}>
                    Building Trust in NIL
                  </MenuItem>
                  <MenuItem onClick={handleImpactAthleteJourney}>
                    Impact to Athelete's Journey
                  </MenuItem>
                  <MenuItem onClick={handleNILComplianceAndProcedures}>
                    NIL Compliance & Procedures
                  </MenuItem>
                  <MenuItem onClick={handleAddressingNilInequalityClick}>
                    Addressing NIL Inequality
                  </MenuItem>
                  <MenuItem onClick={handleNILSupportServicesAndFeesClick}>
                    NIL Support Services & Fees
                  </MenuItem>
                </Popover>
              </MenuItem>

              {userLoginDetails?.user_id && (
                <MenuItem
                  onMouseEnter={handleAccountOpen}
                  onMouseLeave={handleAccountClose}
                >
                  <span
                    className={`navbar-link-dropdown ${
                      activeLink === "AccountInformation" ||
                      activeLink === "DeleteScreen"
                        ? "active"
                        : ""
                    }`}
                    onClick={toggleAdminDropdown}
                  >
                    Account <MdArrowDropDown />
                  </span>
                  <Popover
                    open={isAccountOpen}
                    anchorEl={accountAnchorEl}
                    onClose={handleAccountClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                  >
                    <MenuItem onClick={handleProfile}>
                      Account Information
                    </MenuItem>
                    <MenuItem onClick={handleDeleteAccount}>
                      Delete Account
                    </MenuItem>
                  </Popover>
                </MenuItem>
              )}

              {userLoginDetails?.user_id ? (
                <MenuItem onClick={handleClose}>
                  <span
                    className="navbar-btn navbar-login"
                    onClick={handleLogout}
                  >
                    Logout
                  </span>
                </MenuItem>
              ) : (
                <MenuItem onClick={handleLoginIn}>
                  <span className="navbar-btn navbar-login">Login</span>
                </MenuItem>
              )}
            </Menu>
          </header>
        </>
      ) : (
        <>
          <header className="navbar-container d-flex navbar-flex">
            <div className="navbar-logo d-none d-lg-block">
              <li onClick={handleHomePageLogo} className="nil-head-2">
                <img src={websitelogo} alt="Logo" className="websitelogo" />{" "}
                NIL-Collab
              </li>
            </div>
            <div className="navbar-logo-mobile d-block d-lg-none">
              <a href=""></a>
            </div>
            <nav className="navbar-menu">
              <ul className="navbar-list">
                {/* Global search. The catalogue had 25,566 athletes and no
                    search box anywhere. */}
                <li className="navbar-search-item">
                  <SiteSearch />
                </li>

                <li onClick={handleHomePage}>
                  <a
                    className={`navbar-link ${
                      activeLink === "home" ? "active" : ""
                    }`}
                  >
                    Home
                  </a>
                </li>

                {/* Browse was unreachable from the header — the only way into
                    the catalogue was via the landing page cards. */}
                <li onClick={() => navigate("/browse")}>
                  <a
                    className={`navbar-link ${
                      activeLink === "browse" ? "active" : ""
                    }`}
                  >
                    Browse
                  </a>
                </li>
                <li onClick={() => navigate("/sports")}>
                  <a
                    className={`navbar-link ${
                      activeLink === "sports" ? "active" : ""
                    }`}
                  >
                    Sports
                  </a>
                </li>
              </ul>
            </nav>
            <div className="navbar-actions">
              <ul className="navbar-actions-list">
                {userLoginDetails?.user_id ? (
                  <li
                    className="navbar-dropdown"
                    onClick={handleFavoriteAthletes}
                  >
                    <a
                      className={`navbar-link ${
                        activeLink === "favorites" ? "active" : ""
                      }`}
                    >
                      Favorite Athletes
                    </a>
                  </li>
                ) : null}
                <li className="navbar-dropdown" onClick={handleAboutUs}>
                  <a
                    className={`navbar-link-dropdown ${
                      activeLink === "about" ? "active" : ""
                    }`}
                  >
                    About Us
                  </a>
                </li>
                {/* {!userLoginDetails?.user_id ? (
                  <li onClick={handleCreateAthleteProfile}>
                    <a
                      className={`navbar-link ${
                        activeLink === "createAthleteProfile" ? "active" : ""
                      }`}
                    >
                      Get Recognized Today <br /> Create your Athlete NIL
                      Profile
                    </a>
                  </li>
                ) : (
                  ""
                )} */}

                <li className="navbar-dropdown" ref={dropdownRef}>
                  <button
                    onClick={toggleDropdown}
                    aria-label="Open menu"
                    className="navbar-link-dropdown"
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                  >
                    <MdMenu size={24} />
                  </button>
                  {isDropdownOpen && (
                    <div className="navbar-dropdown-menu">
                      <ul className="aboutus_dropdowns">
                        <li onClick={handleAboutMission}>
                          <p>Building Trust in NIL</p>
                        </li>
                        <li onClick={handleImpactAthleteJourney}>
                          <p>Impact to Athelete's Journey</p>
                        </li>
                        <li onClick={handleNILComplianceAndProcedures}>
                          <p>NIL Compliance & Procedures</p>
                        </li>
                        <li onClick={handleAddressingNilInequalityClick}>
                          <p>Addressing NIL Inequality</p>
                        </li>
                        <li onClick={handleNILSupportServicesAndFeesClick}>
                          <p>NIL Support Services</p>
                        </li>
                      </ul>
                    </div>
                  )}
                </li>

                {userLoginDetails?.user_id && (
                  <li className="navbar-dropdown" ref={adminDropdownRef}>
                    <a
                      className={`navbar-link-dropdown ${
                        activeLink === "AccountInformation" ||
                        activeLink === "DeleteScreen"
                          ? "active"
                          : ""
                      }`}
                      onClick={toggleAdminDropdown}
                    >
                      Account <MdArrowDropDown />
                    </a>
                    {isAdminDropdown && (
                      <div className="navbar-dropdown-menu">
                        <ul className="aboutus_dropdowns">
                          <li onClick={handleProfile}>
                            <p>Account Information</p>
                          </li>
                          {/* <li onClick={handleDeleteAccount}><p>Delete Account</p></li> */}
                        </ul>
                      </div>
                    )}
                  </li>
                )}
                {userLoginDetails?.user_id && (
                  <>
                    <div className="username-nil">
                      Hello,{" "}
                      {profileInfo
                        ? profileInfo
                        : showFallback
                        ? userLoginDetails?.given_name ||
                          userLoginDetails?.user_email
                        : ""}{" "}
                      {/* empty for first 2 seconds */}
                    </div>
                    <li onClick={handleLogout}>
                      <a className="navbar-btn navbar-login">
                        <FaRegUserCircle /> Logout
                      </a>
                    </li>
                  </>
                )}
                {!userLoginDetails?.user_id && (
                  <li onClick={handleLoginIn}>
                    <a className="navbar-btn navbar-login">
                      <FaRegUserCircle /> Login
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </header>
        </>
      )}

      {/* NEW: Modal container for the Add Details form (we'll drop your form here next) */}
      <Dialog
        open={isAddDetailsOpen}
        onClose={closeAddDetails}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Create Your Profile</DialogTitle>
        <DialogContent dividers>
          {/* Replace this with your provided form markup next */}
          <div
            className="add-details-form-placeholder"
            style={{ padding: "12px 0" }}
          >
            {/* Keep CSS simple; your incoming form can reuse existing classes */}
            <Typography variant="body2">
              Form goes here. Paste the sample form you’ll share next.
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAddDetails}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Header;
